import React from "react";
import {
  Image,
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Font,
} from "@react-pdf/renderer";
import fontBold from "../assests/fonts/NotoSansTamil-Bold.ttf";
import fontRegular from "../assests/fonts/NotoSansTamil-Regular.ttf";

Font.register({
  family: "NotoSansTamil",
  fonts: [
    { src: fontRegular, fontWeight: "normal" },
    { src: fontBold, fontWeight: "bold" },
  ],
});

// Create styles for exact alignment and layout
const styles = StyleSheet.create({
  print: {
    fontWeight: "bold",
    fontSize: 16,
    textAlign: "right",
  },
  page: {
    padding: 10,
    fontSize: 10,
    fontFamily: "Helvetica",
    border: "2 solid black",
  },
  container: {
    padding: 10,
    marginTop: 10,
  },
  headerContainer: {
    borderBottom: "1 solid black",
    border: "1 solid black",
    padding: 0,
    marginBottom: 5,
  },
  headerTop: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  headerLeft: {
    width: "30%",
    paddingRight: 0,
    textAlign: "left",
    paddingLeft: 3,
  },
  headerRight: {
    width: "40%",
    padding: 0,
    textAlign: "right",
    paddingRight: 3,
  },
  headerImgLeft: {
    width: "10%",
    paddingRight: 0,
    marginBottom: 10,
  },
  headerImgRight: {
    width: "10%",
    padding: 0,
    marginRight: 8,
    marginBottom: 10,
  },
  headerCenter: {
    width: "80%",
    textAlign: "center",
    paddingBottom: 10,
  },
  centerContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    paddingBottom: 0,
    borderBottom: "1 solid black",
  },
  paddingBottom: {
    paddingBottom: 10,
    marginLeft: 2,
    fontSize: 12,
    fontWeight: "bold",
    textAlign: "left",
  },
  paddingBottomName: {
    paddingBottom: 10,
    marginLeft: 2,
    fontSize: 13,
    fontWeight: "bold",
    textAlign: "left",
  },
  partyName: {
    fontSize: 17,
    fontWeight: "bold",
  },
  partyadd: {
    fontSize: 14,
  },
  invoice: {
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 2,
    textAlign: "center",
    fontSize: 10,
    fontWeight: "bold",
    borderBottom: "1 solid black",
  },
  bill_no: {
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 2,
    textAlign: "center",
    fontSize: 10,
    fontWeight: "bold",
  },
  date: {
    marginTop: 8,
    paddingTop: 8,
    paddingBottom: 5,
    borderTop: "1 solid black",

    paddingLeft: 2,
    textAlign: "center",
    fontSize: 10,
    fontWeight: "bold",
  },
  marginLeft: {
    marginLeft: 2,
    marginBottom: 2,
    fontSize: 12,
    fontWeight: "bold",
    textAlign: "left",
  },
  image: {
    width: "60px",
    height: "70px",
  },
  invoiceSpace: {
    paddingLeft: 2,
    marginTop: 0,
    marginBottom: 0,
  },
  dateSpace: {
    paddingLeft: 2,
    marginTop: 8,
  },
  companyTitle: {
    fontSize: 18,
    fontWeight: "bold",
    textAlign: "center",
    letterSpacing: 0,
    textTransform: "uppercase",
    color: "black",
    textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
  },
  taxWrapper: {
    backgroundColor: "black",
    alignSelf: "flex-start",
    paddingHorizontal: 5,
    borderRadius: 5,
    marginLeft: 180,
  },
  companyTaxTitle: {
    fontSize: 13,
    fontWeight: "bold",
    textAlign: "center",
    color: "white",
  },
  companyMargin: {
    textAlign: "center",
    paddingTop: 5,
  },
  companyHeadMargin: {
    textAlign: "center",
    marginBottom: 0,
    paddingRight: 30,
  },
  contactInfo: {
    fontSize: 10,
  },
  gstNumber: {
    fontSize: 10,
    marginTop: 2,
  },
  invoiceDetailsContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  sectionLeft: {
    width: "75%",
  },
  marginBottom: {
    marginTop: 3,
    marginBottom: 3,
    marginLeft: 3,
    fontSize: 13,
  },
  marginBottomTwo: {
    marginLeft: 5,
    fontSize: 13,
  },
  marginBottomThree: {
    marginLeft: 3,
    fontSize: 13,
  },
  sectionRight: {
    width: "25%",
    textAlign: "left",
    borderLeft: "1 solid black",
  },
  bold: {
    fontSize: 13,
    fontWeight: "bold",
  },
  tableHeader: {
    flexDirection: "row",
    borderTop: "1 solid black",
    borderBottom: "1 solid black",
    backgroundColor: "#f0f0f0",
    paddingVertical: 0,
    width: "100%",
    fontWeight: "bold",
  },
  tableRow: {
    flexDirection: "row",
    borderBottom: "1 solid black",
    Height: 20,
  },
  tableCol: {
    display: "flex",
    width: "8%",
    borderRight: "1 solid black",
    textAlign: "center",
    alignItems: "center",
    paddingVertical: 9,
  },
  tableColl: {
    width: "8%",
    borderRight: "1 solid black",
    textAlign: "center",
    paddingVertical: 8,
    fontSize: 10,
    fontWeight: "bold",
  },
  valueTableCol: {
    width: "18%",
    borderRight: "1 solid black",
    textAlign: "center",
    paddingVertical: 10,
  },
  tablePrice: {
    display: "flex",
    flexDirection: "column",
    width: "18%",
    borderRight: "1 solid black",
    textAlign: "center",
    paddingVertical: 3,
  },
  tableeRate: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    textAlign: "center",
    fontSize: 13,
    fontWeight: "bold",
  },
  tableeAmount: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    textAlign: "center",
    fontSize: 13,
    fontWeight: "bold",
  },
  tableRate: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    alignItems: "center",
    textAlign: "center",
  },
  tableAmount: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    textAlign: "center",
  },
  tableRsValue: {
    width: "70%",
    borderRight: "1 solid black",
    textAlign: "center",
    paddingVertical: 10,
  },
  tablePsValue: {
    width: "30%",
    textAlign: "center",
    paddingVertical: 10,
  },
  tableRs: {
    width: "70%",
    textAlign: "center",
  },
  tablePs: {
    width: "30%",
    textAlign: "center",
  },
  tableColFirst: {
    width: "20%",
    borderLeft: "1 solid black",
    borderRight: "1 solid black",
    textAlign: "center",
    display: "flex",
    paddingTop: 9,
    alignItems: "center",
  },
  tableCollFirst: {
    width: "20%",
    borderLeft: "1 solid black",
    borderRight: "1 solid black",
    textAlign: "center",
    paddingVertical: 8,
    fontSize: 13,
    fontWeight: "bold",
  },
  tableColLarge: {
    width: "30%",
    borderRight: "1 solid black",
    textAlign: "center",
    paddingTop: 9,
  },
  tableCollLarge: {
    width: "30%",
    borderRight: "1 solid black",
    textAlign: "center",
    paddingVertical: 8,
    fontSize: 13,
    fontWeight: "bold",
  },
  footerContainer: {
    marginTop: 5,
    paddingTop: 0,
    borderTop: "1 solid black",
    border: "1 solid black",
  },
  borderTop: {
    borderTop: "1 solid black",
    paddingVertical: 6,
  },
  footerLeft: {
    width: "70%",
    borderRight: "1 solid black",
    padding: 0,
  },
  footerRight: {
    width: "15%",
    padding: 0,
  },
  footerRightt: {
    width: "15%",
    borderLeft: "1 solid black",
    padding: 0,
  },
  firstFooterOne: {
    borderRight: "1 solid black",
    width: "45%",
    textAlign: "right",
  },
  firstFooterTwo: {
    paddingVertical: 7,
    fontSize: 10,
  },
  secondFooterOne: {
    borderRight: "1 solid black",
    width: "35%",
    textAlign: "center",
  },
  secondFooterTwo: {
    paddingVertical: 9,
  },
  thirdFooterOne: {
    width: "20%",
    textAlign: "center",
  },
  thirdFooterTwo: {
    paddingVertical: 9,
  },
  footerSign: {
    marginBottom: 20,
    fontFamily: "Helvetica",
  },
  footerRightSign: {
    alignSelf: "flex-end",
    float: "right",
  },
  footerBottom: {
    flexDirection: "column",
    borderTop: "1 solid black",
    marginTop: 3,
    marginBottom: 3,
    justifyContent: "space-between",
    border: "1 solid black",
  },
  footerLeftOne: {
    paddingTop: 5,
  },
  footerLeftTwo: {
    borderTop: "1 solid black",
    paddingTop: 5,
  },
  footerRightOne: {
    paddingTop: 51,
  },
  footerRightTwo: {
    borderTop: "1 solid black",
    paddingTop: 50,
  },
  footerNote: {
    fontSize: 8,
    textAlign: "center",
  },
  topHead: {
    fontFamily: "NotoSansTamil",
    paddingRight: 10,
    marginTop: -10,
    marginBottom: 5,
  },
  row: {
    flexDirection: "row",
    marginVertical: 3,
    fontSize: 13,
  },
  label: {
    width: 180,
    fontSize: 13,
  },
  value: {
    fontSize: 13,
  },
});

// Helper function to split values into Rs and Ps
const splitIntoRsPs = (value) => {
  if (!value || isNaN(value)) return { rs: "", ps: "" };
  const [rs, ps] = value.toFixed(2).split(".");
  return { rs, ps };
};

function convertRupeesToWordsWithBreaks(amount) {
  const ones = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
  ];
  const teens = [
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];
  const tens = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];
  const thousands = ["", "Thousand", "Lakh", "Crore"];

  function convertGroup(number, thousandIndex) {
    if (number === 0) return "";
    let str = "000" + number;
    str = str.slice(-3);
    const hundred = parseInt(str[0], 10);
    const ten = parseInt(str[1], 10);
    const one = parseInt(str[2], 10);
    let words = [];
    if (hundred > 0) {
      words.push(ones[hundred] + " Hundred");
    }
    if (ten === 1) {
      words.push(teens[one]);
    } else {
      if (ten > 0) {
        words.push(tens[ten]);
      }
      if (one > 0) {
        words.push(ones[one]);
      }
    }
    if (thousandIndex > 0 && words.length > 0) {
      words.push(thousands[thousandIndex]);
    }
    return words.join(" ");
  }

  function convertIntegerPart(integerPart) {
    const groups = [];
    let thousandIndex = 0;
    while (integerPart > 0) {
      const divisor = thousandIndex === 1 ? 100 : 1000;
      groups.push(convertGroup(integerPart % divisor, thousandIndex));
      integerPart = Math.floor(integerPart / divisor);
      thousandIndex++;
    }
    const resultGroups = groups.reverse().filter((group) => group !== "");
    const lastGroupIndex = resultGroups.length - 1;
    const formattedGroups = resultGroups.map((group, index) =>
      index === lastGroupIndex ? `${group}` : group
    );
    return formattedGroups.join(" ");
  }

  function convertDecimalPart(decimalPart) {
    if (decimalPart === 0) {
      return "";
    }
    let paise = Math.round(decimalPart * 100);
    return `${convertGroup(paise, 0)} Paise`;
  }

  const integerPart = Math.floor(amount);
  const decimalPart = amount - integerPart;
  const integerWords = convertIntegerPart(integerPart);
  const decimalWords = convertDecimalPart(decimalPart);
  const result =
    integerWords + " Rupees" + (decimalWords ? "\nAnd " + decimalWords : "");
  return result.trim();
}

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const currentYear = date.getFullYear().toString();
  return `${day}/${month}/${currentYear}`;
};

// Create Document Component
const WholeSalePdf = ({ data, type, previousInvoices }) => {
  const words = convertRupeesToWordsWithBreaks(data.final_total);

  // Calculate Upto Previous Bill Amount
  const uptoPreviousBillAmount = previousInvoices
    .filter((invoice) => invoice.invoice_id < data.invoice_id)
    .reduce((sum, invoice) => sum + parseFloat(invoice.final_total || 0), 0);

  let totalCGST = 0;
  let totalSGST = 0;
  let totalIGST = 0;

  data.products.forEach((product) => {
    if (product.tax_type === "GST") {
      const halfTax = product.tax_amt / 2;
      totalCGST += halfTax;
      totalSGST += halfTax;
    } else {
      totalIGST += product.tax_amt;
    }
  });

  const IGST = data.products.reduce(
    (acc, product) => acc + parseFloat(product.tax_amt),
    0
  );
  const SGST = data.products.reduce(
    (acc, product) => acc + parseFloat(product.tax_amt / 2),
    0
  );
  const CGST = data.products.reduce(
    (acc, product) => acc + parseFloat(product.tax_amt / 2),
    0
  );

  const rowsPerPage =
    data.products.length >= 8 ? (data.products.length >= 10 ? 10 : 12) : 13;
  const productChunks = [];
  for (let i = 0; i < data.products.length; i += rowsPerPage) {
    productChunks.push(data.products.slice(i, i + rowsPerPage));
  }

  return (
    <Document>
      {productChunks.map((productChunk, pageIndex) => (
        <Page size="A4" style={styles.page} key={pageIndex}>
          <View style={styles.container}>
            {/* Header */}
            {/* <Text style={[styles.print]}>[{type}] </Text> */}
            <View style={styles.headerContainer}>
              <View style={styles.headerTop}>
                <View style={styles.headerLeft}>
                  <Text>GSTIN: 33ABVFS0892G1ZQ</Text>
                </View>
                <View style={styles.headerRight}>
                  {/* <Text style={styles.invoiceSpace}>Phone no: 87543 28202</Text> */}
                </View>
              </View>
              <View style={styles.centerContainer}>
                <View style={styles.headerImgLeft}>
                  <Image
                    src="https://t4.ftcdn.net/jpg/01/25/63/07/360_F_125630792_Y7FBQO4f779brbK3kw87iIihK7GE0aAO.jpg"
                    style={styles.image}
                  />
                </View>
                <View style={styles.headerCenter}>
                  {/* <Text style={styles.topHead}>ஸ்ரீ மூர்த்தி அம்மன் துணை</Text> */}
                  <View style={styles.taxWrapper}>
                    <Text style={styles.companyTaxTitle}> INVOICE </Text>
                  </View>
                  <Text style={styles.companyTitle}>SUBHA AGENCY</Text>
                  <Text style={styles.companyMargin}>
                    No. 7/207, Perapatti Road,
                  </Text>
                  <Text style={styles.companyMargin}>
                    (Sattur to Sivakasi Main Road)
                  </Text>
                  <Text style={styles.companyMargin}>
                    ANUPPANKULAM BUS STOP - 626 189.
                  </Text>
                </View>
                <View style={styles.headerImgRight}>
                  <Image
                    src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQHSN-BemaprtWLPemWtPu1eaqXRnIjBlhsxWbbTNFjc6TEQTOCZAnVoKaVpNwImW3qWsc&usqp=CAU"
                    style={styles.image}
                  />
                </View>
              </View>
              <View style={styles.invoiceDetailsContainer}>
                <View style={styles.sectionLeft}>
                  <Text style={styles.paddingBottomName}>
                    Name : {data.partyname}
                  </Text>
                  <Text style={styles.paddingBottom}>
                    Address: {data.partyaddress}
                  </Text>
                  <Text style={styles.paddingBottomName}>
                    State : {data.state}
                  </Text>
                  <Text style={styles.paddingBottom}>
                    GST IN: {data.purchase_gst}
                  </Text>
                </View>
                <View style={styles.sectionRight}>
                  <Text style={styles.invoice}>Invoice No:</Text>
                  <Text style={styles.bill_no}>{data.bill_no}</Text>
                  <Text style={styles.date}>
                    Date: {formatDate(data.bill_date)}
                  </Text>
                </View>
              </View>
            </View>
            {/* Table Header */}
            <View style={styles.tableHeader}>
              <Text style={styles.tableCollFirst}>S.No</Text>
              <Text style={styles.tableCollLarge}>Particulars</Text>
              <Text style={styles.tableColl}>Quantity</Text>
              <View style={styles.tablePrice}>
                <Text style={styles.bold}>Rate</Text>
                {/* <View style={styles.tableeRate}>
                  <Text style={styles.tableRs}>Rs.</Text>
                  <Text style={styles.tablePs}>Ps.</Text>
                </View> */}
              </View>
              <Text style={styles.tableColl}>Per</Text>
              <View style={styles.tablePrice}>
                <Text style={styles.bold}>Amount</Text>
                {/* <View style={styles.tableeAmount}>
                  <Text style={styles.tableRs}>Rs.</Text>
                  <Text style={styles.tablePs}>Ps.</Text>
                </View> */}
              </View>
            </View>
            {/* Table Rows */}
            {Array.from({ length: rowsPerPage }).map((_, index) => {
              const product = productChunk[index]; // might be undefined
              const hasData = !!product;

              const qty = hasData ? product.qty || "" : "";
              const priceUnit = hasData ? product.price_unit || "" : "";
              const amount = qty && priceUnit ? qty * priceUnit : "";
              const perRateSplit = splitIntoRsPs(priceUnit || 0);
              const amountSplit = splitIntoRsPs(amount || 0);

              return (
                <View style={styles.tableRow} key={index}>
                  <Text style={styles.tableColFirst}>
                    {hasData ? index + 1 : ""}
                  </Text>
                  <Text style={styles.tableColLarge}>
                    {hasData ? product.product_name || "" : ""}
                  </Text>
                  <Text style={styles.tableCol}>{qty}</Text>
                  <View style={styles.valueTableCol}>
                    <Text>{hasData ? perRateSplit.rs : ""}</Text>
                  </View>
                  <Text style={styles.tableCol}>
                    {hasData ? product.unit_name || "" : ""}
                  </Text>
                  <View style={styles.valueTableCol}>
                    <Text>{hasData ? amountSplit.rs : ""}</Text>
                  </View>
                </View>
              );
            })}

            <View style={styles.footerContainer}>
              <View style={{ flexDirection: "row" }}>
                <View style={styles.footerLeft}>
                  <View style={styles.footerLeftOne}>
                    <View style={styles.row}>
                      <Text style={styles.label}>
                        Upto Previous Bill Amount
                      </Text>
                      <Text style={styles.value}>
                        : {uptoPreviousBillAmount}
                      </Text>
                    </View>
                    <View style={styles.row}>
                      <Text style={styles.label}>This Bill Amount</Text>
                      <Text style={styles.value}>
                        : {parseFloat(data.final_total)}
                      </Text>
                    </View>
                    <View style={styles.row}>
                      <Text style={styles.label}>Total</Text>
                      <Text style={styles.value}>
                        :{" "}
                        {uptoPreviousBillAmount + parseFloat(data.final_total)}
                      </Text>
                    </View>
                  </View>
                  <View style={styles.footerLeftTwo}>
                    <Text style={styles.marginBottom}>
                      This Sales under GST Composition.
                    </Text>
                    <Text style={styles.marginBottom}>
                      Taxable person not eligible to collect
                    </Text>
                    <Text style={styles.marginBottom}>Tax on supplies.</Text>
                  </View>
                </View>
                <View style={styles.footerRight}>
                  <View style={styles.footerRightOne}>
                    {" "}
                    <Text style={styles.marginBottomTwo}>Total</Text>
                  </View>
                  <View style={styles.footerRightTwo}>
                    <Text style={styles.marginBottomThree}>Total</Text>
                  </View>
                </View>
                <View style={styles.footerRightt}>
                  <View style={styles.footerRightOne}>
                    {" "}
                    <Text style={styles.marginBottomTwo}>
                      {parseFloat(data.final_total)}
                    </Text>
                  </View>
                  <View style={styles.footerRightTwo}>
                    <Text style={styles.marginBottomThree}>
                      {parseFloat(data.final_total)}
                    </Text>
                  </View>
                </View>
              </View>
            </View>
            {/* Footer Bottom */}
            <View style={[styles.footerBottom]}>
              <View style={[styles.headerTop]}>
                <Text>Rupees : {words} Only</Text>
                <Text style={[styles.footerSign]}>For SUBHA AGENCY</Text>
              </View>
              <View style={styles.footerRightSign}>
                <Text>Partner</Text>
              </View>
            </View>
            <View style={styles.footerNote}>
              <Text>Thank you</Text>
            </View>
          </View>
        </Page>
      ))}
    </Document>
  );
};

export default WholeSalePdf;
